// extracted by mini-css-extract-plugin
module.exports = {"homeScreenContainer":"Home_homeScreenContainer__1E_en","header":"Home_header__wDYyq","triviaButton":"Home_triviaButton__-UkVO","subtext":"Home_subtext__1i9h1"};